
import React from 'react';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { PickTicketInfoModalStore } from 'application/pick-ticket-new-flow/stores';
import { PickTicketInfoModalTemplate } from 'themes/application/pick-ticket-new-flow/components';

@setCurrentView((rootStore, componentProps) => new PickTicketInfoModalStore(rootStore, componentProps), 'pickTicketInfoModalStore')
@observer
class PickTicketInfoModal extends React.Component {
    render() {
        return <PickTicketInfoModalTemplate {...this.props} />
    }
}

export default PickTicketInfoModal;
